import React from 'react';
import classNames from 'classnames';
import { domProps } from 'shared/utils/form';
import Input, { readOnlyAttrs } from './Input';

/**
 * @type {import('./types').FieldTransformStrategy}
 */
const transform = {
  fromServer: Input.transform.fromServer,
  toServer: Input.transform.toServer,
  defaultValue: Input.transform.defaultValue,
};

const Textarea = React.memo(function Textarea({
  name,
  register,
  displayName,
  required = false,
  readOnly,
  ...props
}) {
  return (
    <textarea
      id={name}
      className={classNames(
        'w-100 h-input p-2 mb-4 fs-7 fw-normal lh-sm border-0 border-bottom border-input',
        readOnly && 'bg-light text-muted cursor-not-allowed'
      )}
      placeholder={displayName}
      {...register(name, { required })}
      {...(readOnly && readOnlyAttrs)}
      {...domProps(props)}
    />
  );
});

Textarea.transform = transform;
export default Textarea;
